
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import SideBar from './SideBar';
import { IoIosRefresh } from "react-icons/io";

function Header() {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };


  const refreshPage = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.classList.add('sidebar-open');
      document.body.classList.remove('sidebar-closed');
    } else {
      document.body.classList.add('sidebar-closed');
      document.body.classList.remove('sidebar-open');
    }
  }, [isSidebarOpen]);

  const name = localStorage.getItem("name");
  const image = localStorage.getItem("image");

  const logOut = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <>
      <div className="top_nav">
        <div className="nav_menu">
          <nav>
            <div className="nav toggle">
              <button className="btn toggle-btn" onClick={toggleSidebar}>
                <i className="fa fa-bars"></i>
              </button>

              <Link className="admin-profile" to={"/profile"}>
                {/* <div className="admin-profile-img">
                  <img src={process.env.REACT_APP_URL + image || 'img/profile-img.png'} alt=" " style={{ height: "45px" }} />
                </div> */}
                <p>{name || "Admin"}</p>
              </Link>

            </div>
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a
                 type='button'
                  className="btn btn-link nav-link"
                  onClick={refreshPage}
                  title="Refresh Page"
                  style={{
                    background: 'transparent',
                    border: 'none',
                      cursor: 'pointer',
                      fontSize:"28px"
                  }}
                >
                  <IoIosRefresh/>
                </a>
              </li>
              <li>
                <a href="#supportModal" data-bs-toggle="modal">
                  <img src="img/chat.svg" alt="Support" />
                </a>
              </li>
              <li>
                <a href="#confirmationModel" data-bs-toggle="modal">
                  <img src="img/logout.svg" alt="Log Out" />
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div
        className="modal fade support-modal"
        id="supportModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Support</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body  ">
              <div className="row align-items-center">
                <div className="col-md-5">
                  <img src="img/support-img.svg" className='img-fluid' alt="" />
                </div>
                <div className="col-md-7">
                  <ul className="list-unstyled">
                    <li>
                      <span>
                        <i className="fa fa-phone" />
                      </span>
                      <a href="tel:+91">+91 </a>
                    </li>
                    <li>
                      <span>
                        <i className="fa fa-envelope" />
                      </span>
                      <a href="mailto:">
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div
        className="modal fade support-modal"
        id="confirmationModel"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Log Out</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body px-5 pb-0">
              <div className="row align-items-center">
                <div className="modal-body py-4 px-md-5 text-center">
                  <h4>Warning !!</h4>
                  <p className="desc my-2">Are you sure you want to Log Out ?</p>
                  <div className="donate-btn-grp text-center py-4 d-flex">
                    <button className="site-btn btn-blue delete-btn "
                      data-bs-dismiss="modal"
                      aria-label="Close">No</button>
                    <button className="site-btn btn-red delete-btn" onClick={logOut}>Yes </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBar isOpen={isSidebarOpen} togglesidebarbutton={toggleSidebar} />
    </>



  )
}

export default Header